const toggleCommitForm = e => {
    e.preventDefault();
    console.log("clicked toggleCommitForm")
    let button = e.target.classList.contains('button') ? e.target : e.target.closest('.button');

    let buttonState = button.dataset.buttonState;
    let section = button ? button.closest('.assessment-section') : false;
    let block = section ? section.querySelector('.assessment-block') : false;
    if(section && block){ 
        if(buttonState === 'initial'){
            block.classList.remove('initial');
            button.dataset.buttonState = "toggleOn"
            selfctrl_toggletext(button)     

        } else {
            if(buttonState === "toggleOn"){
                block.classList.add('toggleOff');
                button.dataset.buttonState = 'toggleOff';  
                selfctrl_toggletext(button)     
            } else {
                block.classList.remove('toggleOff');
                button.dataset.buttonState = 'toggleOn';
                selfctrl_toggletext(button)   
            }
        }
    }
}
const selfctrl_toggletext = (button) => {
    let toggletext = button.dataset.toggleText;
    let title = button.innerText
    button.innerHTML = toggletext ? toggletext : title;
    button.dataset.toggleText = title;
}
const spin = (target, text) => {
    var markup = '<h5>';
    markup += text + '</h5><div class="la-square-jelly-box la-dark la-2x">';
    markup += '<div></div><div></div></div>';
    target.innerHTML = markup;
  };
const submitCommit = e => {
    e.preventDefault();

    let button = e.target.classList.contains('button') ? e.target : e.target.closest('.button');
    let form = button ? button.closest('FORM') : false;
    if(form){

        //get values
        let commit = form.querySelector('[name="commit"]');

        commit = commit ? commit.value : false;
        let commitfor = form.getElementsByTagName("SELECT")[0];
        commitfor = commitfor ? commitfor.value : false;   
        let instead = form.querySelector('[name="instead"]');
        instead = instead ? instead.value : false;
        let timesaved = form.querySelector('[name="timesaved"]');
        timesaved = timesaved ? timesaved.value : false;
        let moneysaved = form.querySelector('[name="moneysaved"]');
        moneysaved = moneysaved ? moneysaved.value : false;
        if(commit){
            if(commitfor){
                if(instead){
                    const location = selfctrl_assessment.ajaxurl + '?action=logged_in_commit';
                    senddata = encodeURIComponent('&userid') + '=' + encodeURIComponent(selfctrl_assessment.userid);
                    senddata+= '&nonce' + '=' + selfctrl_assessment.nonce;
                    senddata += '&' + encodeURIComponent("commit") + '=' + encodeURIComponent(commit);
                    senddata += '&' + encodeURIComponent("commit_for") + '=' + encodeURIComponent(commitfor);
                    senddata += '&' + encodeURIComponent("commit_instead") + '=' + encodeURIComponent(instead);
                    if(timesaved) senddata += '&' + encodeURIComponent("time_saved") + '=' + encodeURIComponent(timesaved);
                    if(moneysaved) senddata += '&' + encodeURIComponent("money_saved") + '=' + encodeURIComponent(moneysaved);
                    spin(form, 'Adding Commitment...');
                    sendit(location, senddata).then( (r) => {
 
                        if(r.status = 200){
                            form.innerHTML = r.response;
                            //remove button
                            let section = form.closest('.assessment-section');
                            if(section){
                                let buttons =section.querySelectorAll('.button.selfctrlbutton');
                                for(let button of buttons) button.remove();
                            }
                        } else {
                            form.innerHTML = "<p>Error with adding commitment</p>";
                            let section = form.closest('.assessment-section');
                            if(section){
                                let buttons =section.querySelectorAll('.button.selfctrlbutton');
                                for(let button of buttons) button.remove();
                            }
                        }
                    });
                } else {
                    let target = form.querySelector('.errorMessage');
                    if(target) target.innerHTML = '<p>Substitute field is mandatory</p>';
                }

            } else {
                let target = form.querySelector('.errorMessage');
                if(target) target.innerHTML = '<p>Timespan field is mandatory</p>';
   
            }
        } else {
            let target = form.querySelector('.errorMessage');
            if(target) target.innerHTML = '<p>Commit field is mandatory</p>';

        }
    } else {
        console.log('Submit Called on ' + e.target + ' but no form found');
    }
}

const sendit = async(location, senddata ) => {
	const settings = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body:senddata
	};
	try {
		const fetchResponse = await fetch(location, settings);
		const receivedata = await fetchResponse.json();
		return receivedata;
	} catch (e) {
	   console.log(e);
		return e;
	} 
}